import Remote from "stimulus-remote-rails";
import {post} from "@rails/request.js";

export default class extends Remote {
  static targets = ["target", "checkbox"];

  connect() {
    super.connect();
    console.log('autosave');

  }

  async postChange(event) {
    const response = await post(this.element.dataset.action, {query: {booking_id: this.checkboxTarget.id}}) // AJAX request
    const html = await response.text;
    this.element.outerHTML = html;

    let totalPax = 0;
    let checkedPax = 0;

    document.querySelectorAll(".booking-line").forEach((line) => {
      if (line.dataset.bookingStatus === "cancelled") return;
      const pax = parseInt(line.dataset.bookingPax || "0", 10) || 0;
      totalPax += pax;
      if (line.classList.contains("checked")) checkedPax += pax;
    });

    const title = document.querySelector("#exampleModalLabel");
    if (title) title.textContent = `${checkedPax}/${totalPax} reservas`;
  }
}
